@if (thresholdAmount) {
  <div class="free-shipping-progress">
    <div class="progress-header mb-2">
      <div class="d-flex justify-content-between align-items-center">
        <span class="progress-label">
          <i class="material-icons me-1">local_shipping</i>
          @if (!isFreeShipping) {
            {{ 'FREE_SHIPPING_PROGRESS' | translate }}
          }
          @if (isFreeShipping) {
            <strong>{{ 'FREE_SHIPPING_UNLOCKED' | translate }}</strong>
          }
        </span>
        @if (!isFreeShipping && showDetails) {
          <span class="progress-amount text-end ps-2">
            <span [innerHTML]="remainingAmount | currencyConvert:currency"></span> {{ 'REMAINING' | translate }}
          </span>
        }
      </div>
    </div>
    <div class="progress-bar-container">
      <div class="progress" style="height: 24px;">
        <div
          class="progress-bar"
        [ngClass]="{
          'bg-success': isFreeShipping,
          'bg-primary': !isFreeShipping
        }"
          role="progressbar"
          [style.width.%]="progressPercentage"
          [attr.aria-valuenow]="progressPercentage"
          aria-valuemin="0"
          aria-valuemax="100">
          @if (progressPercentage > 15) {
            <span class="progress-text">
              {{ progressPercentage | number:'1.0-0' }}%
            </span>
          }
        </div>
      </div>
      <div class="progress-markers d-flex justify-content-between mt-1">
        <small class="text-muted">
          <span [innerHTML]="total | currencyConvert:currency"></span>
        </small>
        <small class="text-muted">
          <span [innerHTML]="thresholdAmount | currencyConvert:currency"></span>
        </small>
      </div>
    </div>
    @if (!isFreeShipping && thresholdAmount) {
      <div class="shipping-info text-end mt-2">
        <small class="text-muted">
          {{ 'SHIPPING' | translate }}:
          <span [innerHTML]="shippingCost | currencyConvert:currency"></span>
        </small>
      </div>
    }
  </div>
}
